import React, { useEffect, useState } from "react";
import { getApi } from "../../../services/api/globalApi";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import AllOrderReportsFilter from "./AllOrderReportsFilter";
import Button from "../../../components/common/button/Button";
import { convertDate } from "../../../utils/convertDate";
import * as XLSX from "xlsx";
import moment from "jalali-moment";
import OrderCard from "../../orders/sub-components/order-card/OrderCard";

function AllOrderReports() {
  const [data, setData] = useState([]);

  const { utils } = useSelector(utilsState);

  const getOrders = async (params) => {
    const path = "admin/reports/withoutPaginateOrders";
    try {
      const response = await getApi({
        path,
        params,
      });
      setData(response.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getOrders(allFilter);
  };

  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const navigate = useNavigate();

  const getOrderInfo = (id) => {
    navigate(`/order-list/${id}`);
  };
  const editOrder = (id) => {
    navigate(`/order-list/${id}`);
  };

  const handleExel = () => {
    const newData = [];
    for (let j = 0; j < data.length; j++) {
      for (let i = 0; i <= data[j]?.products?.length; i++) {
        if (i == 0) {
          newData.push({
            "نام کاربر": data[j]?.user?.name,
            نقش: utils.ROLES[data[j]?.user?.role]?.name,
            "مشتری نماینده": data[j]?.ref ? "بله" : "",
            "موبایل کاربر": data[j]?.user?.mobile,
            "نام مشتری": data[j]?.name,
            "موبایل مشتری": data[j]?.mobile,
            "شماره سفارش": `${data[j]?.trackingCode}`,
            "تخفیف": `${data[j]?.totalDiscount}`,
            "مبلغ پرداختی": `${data[j]?.finalPrice}`,
            "مجموع ناخالص (بدون حملو نقل)": Math.floor(
              data[j]?.totalProductsPrice
            ),
            آدرس: `${data[j]?.province} - ${data[j]?.city}- ${data[j]?.address}`,
            "کد پستی": `${data[j]?.postcode}`,
            تاریخ: convertDate(data[j]?.paymentDate, true) || "",
          });
        } else {
          newData.push({
            نام: "",
            موبایل: "",
            "شماره سفارش": "",
            "نام محصول": data[j]?.products[i - 1].productName,
            تعداد: data[j]?.products[i - 1].count,
          });
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(newData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex items-center justify-between">
        <h3 className="text-gray-800">لیست تمام سفارشات</h3>
        {data?.length ? (
          <Button
            color="success"
            type="button"
            onClick={handleExel}
            text={"خروجی اکسل"}
          />
        ) : null}
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">فهرست سفارش‌ها را با فیلترهای تاریخ، شناسه کالا، کاربر و وضعیت پرداخت نشان می‌دهد. خروجی اکسل از نتیجهٔ فیلترشده گرفته می‌شود.</p>
      <div className="border-b border-gray-200 dark:border-gray-700">
        <AllOrderReportsFilter filterDataHandler={filterDataHandler} />
      </div>
      <div className="mt-4 w-full flex flex-col gap-4">
        {data.length > 0 &&
          data.map((item, index) => {
            return (
              <OrderCard
                reGetData={() => getOrders({})}
                utils={utils}
                key={index}
                data={item}
                editOrder={editOrder}
                getOrderInfo={getOrderInfo}
                showImages={false}
              />
            );
          })}
      </div>
    </div>
  );
}

export default AllOrderReports;
